import { z } from 'zod'

export const rejectBillingSupplyAuthorizationSchema = z.object({
  reject_reason: z.string().min(1, { message: 'Campo obrigatório' }),
})

export type RejectBillingSupplyAuthorizationValidationSchema = z.infer<typeof rejectBillingSupplyAuthorizationSchema>
